import Configuration from '@/agilis/util/Configuration'
import { mapGetters } from 'vuex'

// Mixin providing export methods
export default {
  name: 'DataTableExportMixin',

  data () {
    return {
      xlsxExporting: false
    }
  },

  computed: {
    ...mapGetters({
      'applicationId': 'contextStore/applicationId',
      'workspaceId': 'contextStore/workspaceId',
      'trackerTypeId': 'contextStore/trackerTypeId'
    }),

    xlsxName () {
      // Use datatable title & filterName when available
      if (this.computedTitle) {
        return this.computedViewTitle ? `${this.computedTitle}_${this.computedViewTitle}.xlsx` : `${this.computedTitle}.xlsx`
      }
      return 'export.xlsx'
    },

    xlsxSchema () {
      // Columns: filter columns or datatable columns
      const cols = (this.filterHeaders || this.headers)
        .filter(h => h.value !== 'actions')

      // Map each column into the xlsx schema
      return cols.map((col) => {
        const colId = col.value

        return {
          column: col.text,
          type: String, // Considering everything as string
          value: item => {
            try {
              const value = this.renderColumn(colId, item)
              return value.toString() // Cast output to string
            } catch (e) {
              return ''
            }
          }
        }
      })
    }
  },

  methods: {
    // Export process entry point
    async exportTable () {
      this.xlsxExporting = true
      try {
        // Load the module
        const writeXlsxFileModule = await import('write-excel-file')
        const writeXlsxFile = writeXlsxFileModule.default

        // Fetch the full datatable
        const xlsxItems = await this.fetchXlsxContent()

        // Write the file
        await writeXlsxFile(xlsxItems, {
          schema: this.xlsxSchema,
          fileName: this.xlsxName
        })
      } catch (e) {
        this.notifyError({ message: this.$t('label.exportError') })
        console.error(e)
      }
      this.xlsxExporting = false
    },

    // Fetch search items
    async fetchXlsxContent () {
      const url = this.searchApi

      // Body uptions: force retrieve of full result-set
      const opts = Object.assign({}, this.options)
      opts.itemsPerPage = -1
      opts.page = 1

      const body = Configuration.datatable.paginatedRequestBody(this.dataTableConfiguration, opts, this.searchTxt, this.filterArray, this.filterHeaders)
      const config = this.$axios.agilisRequestConfig(url)
      const response = await this.$axios.post(url, body, config)
      return response.data.items
    }
  }
}
